import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  padding-left:250px;
`;

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 1rem 1.5rem;
`;

export const Title = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 2rem;
  color: #282828;
  font-family: Montserrat;
  margin-bottom: 2rem;
`;

export const VerticalSeparator = styled.div`
  height: 1.5rem;
`;

export const HorizontaSeparator = styled.div`
  width: 1rem;
`;

export const FormSelectorContainer = styled.div`
  display: flex;
`;

export const FormSelectorItemsContainer = styled.div`
  width: 20%;
  border-color: #F47C34;
  border-right-width: 0.2rem;
  border-right-style: solid;
`;

export const FormSelectorItemButton = styled.button`
  width: 100%;
  padding: 1rem;
  background-color: ${props => props.isSelected ? '#F47C34' : 'transparent'};
  color: ${props => props.isSelected ? '#FFF' : '#282828'};
  font-weight: ${props => props.isSelected ? 600 : 400};
  border: none;
  font-family: Montserrat;

  
  &:hover {
    cursor: pointer;
  }
`;

export const FormSelectorFormsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  padding: 1rem;
`;

export const FormActionsContainer = styled.div`
  display: flex;
`;

